import React, { Component, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import blogdata from '../../data/blogdata.json';
import { GetBlogList } from '../../request/apiRquest';
import moment from 'moment';


const PostList = () => {

  const [bloglist, setBlogList] = useState([]);

  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'
  let data = blogdata.blogs

  const getbloglist = () => {
    GetBlogList().then((res) => {
      setBlogList(res);
    })
  }

  useEffect(() => {
    getbloglist();
  }, [])


  return (
   <div className="property-news-area pd-top-100 pd-bottom-70">
      <div className="container">
        <div className="row">
          {bloglist?.map((item, i) => (
            <div key={item.ID} className="col-lg-4 mb-4">
              <div className="card h-100 shadow-sm">
                <img
                  src={item.FeaturedImage}
                  className="card-img-top"
                  alt="Blog"
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{item.Title}</h5>
                  <p className="card-text">
                    {item.Content?.substring(0, 150) + "..."}
                  </p>
                  <div className="mt-auto">
                    <p className="text-muted mb-2">
                      <strong>Publish Date:</strong>{" "}
                      {moment(item.publishedDate).format("DD-MM-YYYY")}
                    </p>
                    <Link
                      to={{
                        pathname: `/blogdetails`,
                        search: `?Blog=${item.Slug}`,
                      }}
                      className="btn-sm btn-yellow"
                      
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )

}

export default PostList;
